import React from 'react';
import { MessageDialog, Size } from '@lux/dialog';
import { Voucher } from '@lux/graphics';
export const VoucherModal = ({ event, isShown = true, onClose, onRedeem: onClick, }) => {
    return (React.createElement(MessageDialog, { closeLabel: event.closeText, closeDialog: onClose, closeOnBackdrop: true, graphic: React.createElement(Voucher, null), isShown: isShown, size: Size.S, 
        // eslint-disable-next-line react/no-danger
        text: React.createElement("span", { dangerouslySetInnerHTML: { __html: event.content } }), title: event.title, positiveButtonProps: { onClick }, positiveButtonText: event.ctaText, footNote: event.disclaimer }));
};
//# sourceMappingURL=component.js.map